var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupbuy-list"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("團購中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("團購管理")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("團購管理")])]), _c('div', {
    staticClass: "col-6 d-flex justify-content-end"
  }, [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_CREATE]) ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("我要開團")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "align-items-center mb-2 mb-xl-0"
  }, [_c('b-form-group', {
    staticClass: "flex-shrink-0 ml-1 ml-xl-2 mb-0",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return [_c('b-form-checkbox-group', {
          attrs: {
            "id": "checkbox-group-1",
            "options": _vm.statusOptions,
            "aria-describedby": ariaDescribedby
          },
          on: {
            "change": function change($event) {
              return _vm.handleCheckedTypes();
            }
          },
          model: {
            value: _vm.selectedTypes,
            callback: function callback($$v) {
              _vm.selectedTypes = $$v;
            },
            expression: "selectedTypes"
          }
        })];
      }
    }])
  })], 1)])]), _c('div', {
    staticClass: "d-flex flex-wrap mb-3 justify-content-end"
  }, [_c('div', {
    staticClass: "row-searchbar d-flex mb-2 mb-md-0 mr-md-2"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "120px",
      "height": "45px"
    },
    attrs: {
      "options": _vm.searchOptions
    },
    model: {
      value: _vm.query.keyword_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword_type", $$v);
      },
      expression: "query.keyword_type"
    }
  }), _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.placeholderMap[_vm.query.keyword_type]
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getGroupbuyList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1)], 1), _c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("匯出")])], 1), _c('b-tabs', {
    model: {
      value: _vm.currentTabIndex,
      callback: function callback($$v) {
        _vm.currentTabIndex = $$v;
      },
      expression: "currentTabIndex"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('b-tab', {
      key: tab.status,
      attrs: {
        "title": tab.title
      },
      on: {
        "click": _vm.handleChangeTab
      }
    }, [_c('b-card-text', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.groupbuys,
        "fields": _vm.fields,
        "busy": _vm.isFetchGroupbuyList
      },
      on: {
        "sort-changed": _vm.handleSort
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }, {
        key: "cell(groupbuying_number)",
        fn: function fn(data) {
          return [_c('router-link', {
            attrs: {
              "to": {
                name: 'CoreGroupbuyingDetailV2',
                params: {
                  groupbuyID: data.item.id
                }
              }
            }
          }, [_vm._v(" " + _vm._s(data.item.title)), _c('br'), _vm._v(" " + _vm._s(data.item.groupbuying_number) + " ")]), _c('span', {
            staticClass: "ml-2 cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.showLiffLink(data.item);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-link"
          })])];
        }
      }, {
        key: "cell(title)",
        fn: function fn(data) {
          return [_c('div', [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].title) + " ")]), _c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].sale_page_code) + " ")])];
        }
      }, {
        key: "cell(picture)",
        fn: function fn(data) {
          return [data.item.products[0] && data.item.products[0].image_list[0] && data.item.products[0].image_list[0].pic_url ? _c('b-img-lazy', {
            staticClass: "thumb-image",
            attrs: {
              "src": data.item.products[0] && data.item.products[0].image_list[0] && data.item.products[0].image_list[0].pic_url,
              "alt": "商品圖片",
              "width": "50",
              "height": "50"
            }
          }) : _vm._e()];
        }
      }, {
        key: "cell(branch_name)",
        fn: function fn(data) {
          return [data.item.group ? _c('div', [_vm._v(" " + _vm._s(data.item.group.branch.name) + " ")]) : _vm._e(), data.item.group ? _c('div', {
            staticClass: "mt-1"
          }, [_vm._v(" " + _vm._s(data.item.group.branch.branch_code) + " ")]) : _vm._e()];
        }
      }, {
        key: "cell(group)",
        fn: function fn(data) {
          return [data.item.group ? _c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(data.item.group.name) + " ")]) : _vm._e(), data.item.group ? _c('div', [_vm._v(" " + _vm._s(data.item.group.group_number) + " ")]) : _vm._e()];
        }
      }, {
        key: "cell(date)",
        fn: function fn(data) {
          return [_c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.start_at), "yyyy-MM-dd HH:mm")) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.end_at), "yyyy-MM-dd HH:mm")) + " ")])];
        }
      }, {
        key: "head(tracking_code)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer"
          }, [_vm._v(" 員編 ")])])];
        },
        proxy: true
      }, {
        key: "cell(tracking_code)",
        fn: function fn(data) {
          return [_c('div', [_vm._v(" " + _vm._s(data.item.main_id ? "總公司開團" : data.item.tracking_code) + " ")])];
        }
      }, {
        key: "head(current_quantity)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer"
          }, [_vm._v(" 本團銷量 ")])])];
        },
        proxy: true
      }, {
        key: "cell(current_quantity)",
        fn: function fn(data) {
          return [_vm._v(" " + _vm._s(data.item.current_quantity || 0) + " ")];
        }
      }, {
        key: "cell(adjust_quantity_result)",
        fn: function fn(data) {
          return [_vm._v(" " + _vm._s(data.item.current_quantity + data.item.adjust_quantity) + " ")];
        }
      }, {
        key: "head(date)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer"
          }, [_vm._v(" 開團 ")]), _vm._v(" /結團時間 ")])];
        },
        proxy: true
      }], null, true)
    })], 1)]), _c('CustomPagination', {
      attrs: {
        "currentPage": _vm.query.page,
        "totalRows": _vm.total,
        "perPage": _vm.query.per_page
      },
      on: {
        "page-change": _vm.handlePageChange,
        "per-page-change": _vm.handlePerPageChange
      }
    })], 1)], 1);
  }), 1)], 1), _c('b-modal', {
    attrs: {
      "id": "liff-link-modal",
      "footer-class": "d-flex justify-content-center",
      "hide-header": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "size": "lg",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('liff-link-modal');
            }
          }
        }, [_vm._v("關閉")])];
      },
      proxy: true
    }])
  }, [_c('div', [_vm._v(_vm._s(_vm.selectedGroupbuying.title))]), _c('b-textarea', {
    staticClass: "mt-2",
    on: {
      "click": _vm.selectLiffLink
    },
    model: {
      value: _vm.liffLink,
      callback: function callback($$v) {
        _vm.liffLink = $$v;
      },
      expression: "liffLink"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }